import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ClientMode from '../ClientMode/ClientMode';
import AdvisorMode from '../AdvisorMode/AdvisorMode';

class App extends PureComponent {

  render() {
    return (
      <div>
      {this.props.mode === 'client' &&
        <ClientMode />
      }
      {this.props.mode === 'advisor' && this.props.token &&
        <AdvisorMode />
      }
      <p style={{marginTop:'40px',fontSize:'14px',fontWeight:'300'}}>Access to these tools will be available for a limited period of time.   For more information and how to gain access to these tools after such time, contact your WisdomTree Director or call 1-866-909-WISE to speak with a WisdomTree Representative.</p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mode: state.params.mode,
    clientID: state.params.clientID,
    token: state.params.token,
  };
}

export default connect(mapStateToProps)(App);




// WEBPACK FOOTER //
// ./src/components/App/App.js